define("powergen/router",
  [],
  function() {
    "use strict";
    var router;

    router = Ember.Router.map(function() {
      this.route('index', {
        path: '/'
      });
      this.route('instructions');
      this.route('setup');
      this.route('systems');
      this.route('system', {
        path: '/system/:system_id'
      });
      return this.route('admin');
    });


    return router;
  });